import { Link } from 'react-router-dom';

import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Sidebar from '../../../components/sidebar/Sidebar';

import MapOutlets from "../../../pages/mapOutlets/mapOutlets ";

import SectionContent from '../../../components/sectionContent/sectionContent';

import '../../../scss/App.scss';

const CustomerMapSection = () => {
	const overflowedBtnsCount = 0;

	const availableButtons = [
		{
			component: (
				<HeaderBtn
					content="Легенда"
					purpose="legend"
					modalTitle="Легенда"
				/>
			),
		},
	];

	const filteredAvailableButtons = availableButtons.filter((btn: { component: JSX.Element }) => btn);

	const displayedHeadBtns = filteredAvailableButtons
		?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
		?.map((elem: { component: JSX.Element }, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				headBlockChildren={displayedHeadBtns}
				pageName='reports'
				section='Карта обслуживания'
			>
				<div className="content__main">
					<div className='btns btns_map' >
						<Link to={'/map'} className='tab'>
							<div className='buttons__btn  --active'>Клиент</div>
						</Link>
					</div>
					<div className='content__single_report'>
						<div style={{ height: '15px' }} />
						<MapOutlets />
					</div>
				</div>
			</SectionContent>
		</div>
	);
};

export default CustomerMapSection;